<template>
  <app-page form="xl" class="specialbook-confirm workspace">
    <h1 class="title mb-3">予約内容を確認して下さい</h1>

    <v-card class="text--primary mb-3">
      <v-card-text>
        <p class="mb-0">次の予約内容に間違いがなければ、予約を確定してください。</p>
      </v-card-text>
      <v-card-actions class="px-4">
        <v-spacer/>
        <v-btn
          color="primary" :disabled="!logined || registering"
          @click="onRegister"
        >
          <template v-if="registering">予約中...</template>
          <template v-else>予約確定</template>
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-row class="mb-3">
      <v-col cols="12" sm="6">
        <confirm-charge class="mb-4"/>
        <confirm-summary/>
      </v-col>
      <v-col cols="12" sm="6" :class="{'is-nopadding': breakpoint === BREAKPOINT_XS}">
        <confirm-basic class="mb-4"/>
        <confirm-options class="mb-4"/>
        <confirm-remark/>
      </v-col>
    </v-row>

    <v-dialog
      :value="registered.length > 0"
      persistent
      width="480"
    >
      <v-card>
        <v-card-title
          class="headline primary white--text"
        >
          <template>予約を登録しました</template>
        </v-card-title>

        <v-card-text class="text--primary pt-4">
          <p
            v-for="(line, index) in registered"
            :key="index"
            class="mb-0"
          >
            {{line}}
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary"
            href="https://netzfukuoka.jp/special_rent_a_car"
          >
            TOPページに戻る
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      :value="failed.length > 0"
      width="480"
    >
      <v-card>
        <v-card-title
          class="headline primary white--text"
        >
          <template>予約できませんでした</template>
        </v-card-title>

        <v-card-text class="text--primary pt-4">
          <p
            v-for="(line, index) in failed"
            :key="index"
            class="mb-0"
          >
            {{line}}
          </p>
        </v-card-text>

        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="primary" class="w-24"
            @click="failed = []"
          >
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </app-page>
</template>

<style lang="scss">
@import '@/libs/vuetify/styles/variables.scss';

.v-application .specialbook-confirm {
  @extend %typo-body-1;
  color: $title-black-text-color;

  .is-nopadding {
    padding-top: 0 !important;
  }

  .v-input--checkbox {
    margin-top: 0;
    padding-top: 0;

    .v-input__slot {
      margin-bottom: 0;
    }

    .v-messages {
      display: none;
    }
  }

  .v-card__text {
    color: $title-black-text-color;
  }

  h3 {
    @extend %typo-caption;
    color: $caption-black-text-color;
    margin: {
      top: 1rem;
      bottom: .5rem;
    }
  }

  h3.has-border {
    border-bottom: solid 1px $divider-color;
    margin-bottom: calc(.5rem - 1px);
  }

  h3:first-child {
    margin-top: 0;
  }

  hr {
    margin: 4px 0;
    border: none;
    height: 1px;
    background-color: $divider-color;
  }

  hr.has-space {
    margin-top: 12px;
  }
}
</style>

<script>
import ShopBase from '@/app/special/mixins/ShopBase'
import ConfirmSummary from './ConfirmSummary'
import ConfirmCharge from './ConfirmCharge'
import ConfirmBasic from './ConfirmBasic'
import ConfirmOptions from './ConfirmOptions'
import ConfirmRemark from './ConfirmRemark'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'BookConfirm',
  mixins: [
    ShopBase('予約内容確認')
  ],
  components: {
    ConfirmCharge,
    ConfirmSummary,
    ConfirmBasic,
    ConfirmOptions,
    ConfirmRemark
  },
  data () {
    return {
      confirm: false,
      registering: false,
      registered: [],
      failed: [],
      url: window.location.href
    }
  },
  computed: {
    ...mapGetters('login', [
      'logined'
    ]),

    confirmErrors () {
      return this.confirm ? null : ['チェックが入っていません。']
    }
  },
  methods: {
    ...mapActions('book', [
      'newBook',
      'registerBook'
    ]),

    async onRegister () {
      this.failed = []
      this.registered = []

      this.registering = true
      const result = await this.registerBook()
      this.registering = false

      if (!result.ok) {
        this.failed = result.reasons
      } else {
        this.registered = result.reasons
        this.$gtag.event('succeed', {
          event_category: 'reserve',
          event_label: `shopID: ${this.shopID}`
        })
      }
    },

    async onFinished () {
      // this.newBook({})
      this.$router.push({ name: 'shop' })
    }
  }
}
</script>
